// extracted by mini-css-extract-plugin
module.exports = {"background":"NewPage_background__1C2Ke","box":"NewPage_box__2Fjw_","logout":"NewPage_logout__2Hh-s"};